import { createAsyncThunk } from '@reduxjs/toolkit';
import tobaccoWorkOrderApi from '../../../api/tobaccoWorkOrderApi';

const REDUCER_NAME = 'tobaccoWorkOrders';

export const CreateTobaccoWorkOrder = createAsyncThunk<any, any, { rejectValue: { status: string; message: string } }>(
  `${REDUCER_NAME}/createTobaccoWorkOrder`,
  async (data, thunkAPI) => {
    const res = await tobaccoWorkOrderApi.create(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Error creating tobacco work order' });
  }
);

export const GetTobaccoWorkOrders = createAsyncThunk(`${REDUCER_NAME}/getTobaccoWorkOrders`, async (_, thunkAPI) => {
  const res = await tobaccoWorkOrderApi.get();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Error fetching tobacco work orders' });
});

export const GetTobaccoWorkOrderById = createAsyncThunk<
  any,
  string,
  { rejectValue: { status: string; message: string } }
>(`${REDUCER_NAME}/getTobaccoWorkOrderById`, async (id, thunkAPI) => {
  const res = await tobaccoWorkOrderApi.getById(id);

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Error fetching tobacco work order' });
});

export const UpdateTobaccoWorkOrder = createAsyncThunk<
  any,
  { data: any; id: string },
  { rejectValue: { status: string; message: string } }
>(`${REDUCER_NAME}/updateTobaccoWorkOrder`, async ({ data, id }, thunkAPI) => {
  const res = await tobaccoWorkOrderApi.update(data, id);

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Error updating tobacco work order' });
});

export const DeleteTobaccoWorkOrder = createAsyncThunk<
  any,
  string,
  { rejectValue: { status: string; message: string } }
>(`${REDUCER_NAME}/deleteTobaccoWorkOrder`, async (id, thunkAPI) => {
  const res = await tobaccoWorkOrderApi.delete(id);

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Error deleting tobacco work order' });
});
